import { useState } from "react";
import "./PrivacyPolicy.css"; // Import CSS file

export default function PrivacyPolicy() {
    const [activeSection, setActiveSection] = useState(null);

    const toggleSection = (index) => {
        setActiveSection(activeSection === index ? null : index);
    };

    const sections = [
        {
            title: "Your Privacy Matters",
            content:
                "At Swarna Prakash Jewellers, we deeply respect your privacy and value the trust you place in us. This privacy statement outlines how we gather, store, and use information collected through our website and Swarna Prakash Jewellers Store. By accessing and using our platforms, you agree to abide by the terms of this statement.",
        },
        {
            title: "Collection of Personal Data",
            content:
                "Information You Provide: We receive and store information you submit on our website or in our store, including your name, gender, email address, mobile number, age, and billing information.\n\nAutomated Information: We utilize cookies to collect non-identifiable data.\n\nInformation from Other Sources: CCTV surveillance, images, photographs, and videos may also be collected.",
        },
        {
            title: "Usage of Personal Data",
            content:
                "We use your data to enhance your experience, tailor services, improve our products, safeguard against fraud, administer contests and promotions, communicate orders, troubleshoot issues, and comply with legal requirements.",
        },
        {
            title: "Sharing of Personal Data",
            content:
                "We may share data with third-party vendors, law enforcement agencies, and in business transactions with privacy commitments.",
        },
        {
            title: "Personal Data Protection",
            content:
                "We employ industry-standard security measures, SSL encryption, physical, technical, and administrative safeguards. While total prevention isn't possible, we make reasonable efforts to protect your data.",
        },
        {
            title: "Access and Retention",
            content:
                "You have rights to access, correct, and delete your data. You may opt out of communications at any time. Data is retained for legal and regulatory compliance.",
        },
        {
            title: "Privacy Policy Changes",
            content:
                "We may modify this policy periodically. Continued use implies acceptance.",
        },
        {
            title: "Contact Information",
            content:
                "Swarna Prakash Jewellers, Karla City Centre, Joduraste, Karkala, Udupi District - 576117\nPhone: 7204429777\nEmail: swarnaprakashjewellers@gmail.com\n\nYour privacy is of utmost importance. Contact us with any inquiries.",
        },
    ];

    return (
        <div className="privacy-policy-container container">
            <h1 className="privacy-policy-title">Privacy Policy</h1>
            <div className="privacy-policy-sections">
                {sections.map((section, index) => (
                    <div key={index} className="privacy-policy-section">
                        <button
                            className="privacy-policy-toggle"
                            onClick={() => toggleSection(index)}
                        >
                            <span className="privacy-policy-section-title">
                                {section.title}
                            </span>
                            <span className="privacy-policy-toggle-icon">
                                {activeSection === index ? "-" : "+"}
                            </span>
                        </button>
                        {activeSection === index && (
                            <div className="privacy-policy-content">
                                {section.content}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}